import { httpGet, httpPost } from './api/axios_api';
import Constants from '../constants/constants';
import { player_game_session } from './api/entities';
import actions from './player_game_session_actions';

export async function getPlayerGameSessionsAsync(playerID) {
  const url = `${Constants.BACKEND_URL}/get-player-assigned-game-sessions/${playerID}`;
  return httpGet(url, {});
}

export async function createPlayerGameSessionAsync(playerID, game_session_id) {
  const url = `${Constants.BACKEND_URL}/create-player-game-session`;
  const params = {
    player_id: playerID,
    game_session_id: game_session_id,
  };

  const config = {
    params: params,
  };
  return httpPost(url, config);
}

export async function playerHasSessions(playerID) {
  const url = `${Constants.BACKEND_URL}/player-has-sessions/${playerID}`;
  return httpGet(url, {});
}

export async function getPlayerLastPlayedAssignedSession(playerID) {
  const url = `${Constants.BACKEND_URL}/get-player-last-played-assigned-session/${playerID}`;
  return httpGet(url, {});
}

export function resetGameSessionViewState() {
  return { type: actions.resetPlayerGameSessionViewState };
}

export function resetPlayerGameSessionState() {
  return { type: actions.resetPlayerGameSessionState };
}

export function createPlayerGameSession(gameSessionObject) {
  return player_game_session.create(actions.createPlayerGameSession, gameSessionObject, []);
}

export function updatePlayerGameSession(playerGameSessionId, playerGameSessionObject) {
  return player_game_session.update(actions.updatePlayerGameSession, playerGameSessionId, playerGameSessionObject, []);
}

export function _getPlayerGameSessions(query, sort) {
  return player_game_session.list(actions.listPlayerGameSessions, query, sort);
}

export function getPlayerGameSession(game_sessionId) {
  return player_game_session.get(actions.getPlayerGameSession, game_sessionId, []);
}

export function getPlayerGameSessions(playerID, token) {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/get-player-game-sessions/${playerID}`;
    httpGet(url, {}, token).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.addSessionsToList,
          player_game_sessions: response.data.player_game_sessions,
        });
      } else {
        //TODO: handle results load error
      }
    });
  };
}

export function getPlayerGameSessionResults(playerGameSessionID) {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/get-player-game-session-results/${playerGameSessionID}`;
    httpGet(url, {}).then((response) => {
      if (response.data.success) {
        dispatch({
          type: actions.addPlayerGameSessionResultsToList,
          results: response.data.results,
        });
      } else {
        //TODO: handle results load error
      }
    });
  };
}

const INITIAL_STATE = {
  should_get_player_game_sessions: true,
  should_get_player_game_session_view: true,
  player_game_sessions: [],
  player_game_session: {},
  current_game_session_results: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.resetGameSessionState:
      return {
        ...INITIAL_STATE,
      };
    case actions.resetGameSessionViewState:
      return {
        ...state,
        current_game_session_results: [],
        should_get_player_game_session_view: true,
      };
    case actions.createGameSession:
      return {
        ...state,
        player_game_sessions: action.body ? [...state.game_sessions, action.body] : state.game_sessions,
      };
    case actions.listPlayerGameSessions:
      return {
        ...state,
        player_game_sessions: action.body ? action.body._items : state.game_sessions,
      };
    case actions.addPlayerGameSessionResultsToList:
      return {
        ...state,
        should_get_player_game_session_view: false,
        current_game_session_results: action.results ? action.results : [],
      };
    case actions.getPlayerGameSession:
      return {
        ...state,
        player_game_session: action.body ? action.body : state.player_game_session,
      };
    case actions.updatePlayerGameSession:
      return {
        ...state,
        id: action.body ? action.body : null,
      };
    case actions.addSessionsToList:
      return {
        ...state,
        player_game_sessions: action.player_game_sessions,
        should_get_player_game_sessions: false,
      };
    default:
      return state;
  }
}
